import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

const HamburguerMenuWrapper = styled.div`
  color: ${props => props.theme.v2.palette[ 'TAG1-700' ]};
  font-weight: 700;
  display: flex;
  align-items: center;
`

const StripesWrapper = styled.div`
  width: 20px;
  margin-top: 5px;
  margin-right: 8px;
`

const Stripe = styled.div`
  display: block;
  height: 2px;
  max-width: 20px;
  background: ${props => props.theme.v2.palette[ 'TAG1-700' ]};
  margin-bottom: 5px;
  width: 100%;
`

const HamburguerMenu = ( { onClick, testId } ) => (
  <HamburguerMenuWrapper
    data-testid={ testId }
    onClick={ onClick }
  >
    <StripesWrapper>
      <Stripe />
      <Stripe />
      <Stripe />
    </StripesWrapper>
    Menu
  </HamburguerMenuWrapper>
)

HamburguerMenu.propTypes = {
  'onClick': PropTypes.func.isRequired,
  'testId': PropTypes.string
}

HamburguerMenu.defaultProps = {
  'testId': 'hamburger-menu'
}

export default HamburguerMenu
